import React from 'react';
import {
  FunnelIcon,
  ChevronLeftIcon,
  InformationCircleIcon,
} from '@heroicons/react/24/outline';
import { FailureFilters } from '@/types/filters';
import { Workspace } from '@/types/workspace';
import { ForecastFilters } from './ForecastFilters';
import { Tooltip } from '@/components/ui';

interface ForecastFiltersSidebarProps {
  filters: FailureFilters;
  onFiltersChange: (filters: FailureFilters) => void;
  sourceWorkspace: Workspace | null;
  disabled: boolean;
  isCollapsed?: boolean;
  onToggleCollapse?: () => void;
}

export const ForecastFiltersSidebar: React.FC<ForecastFiltersSidebarProps> = ({
  filters,
  onFiltersChange,
  sourceWorkspace,
  disabled,
  isCollapsed: _isCollapsed = false,
  onToggleCollapse,
}) => {
  return (
    <div className="h-full bg-white border-r border-gray-200 flex flex-col w-80">
      {/* Header */}
      <div className="px-6 py-4 border-b border-gray-200">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center space-x-2">
            <FunnelIcon className="w-5 h-5 text-blue-600" />
            <h3 className="text-lg font-semibold text-gray-900">Forecast Filters</h3>
            <Tooltip
              content="Select a subset of the population used in the source analysis. Only options that were included in the original analysis are available."
              type="info"
            >
              <InformationCircleIcon className="w-4 h-4 text-blue-600 cursor-help" />
            </Tooltip>
          </div>
          {onToggleCollapse && (
            <button
              onClick={onToggleCollapse}
              className="p-1 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100 transition-colors"
              title="Collapse sidebar"
            >
              <ChevronLeftIcon className="h-5 w-5" />
            </button>
          )}
        </div>
        <p className="text-sm text-gray-600">
          Configure forecast data filters
        </p>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-visible">
        <div className="px-6 py-4 space-y-6">
          <ForecastFilters
            filters={filters}
            onFiltersChange={onFiltersChange}
            sourceWorkspace={sourceWorkspace}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
};

export default ForecastFiltersSidebar;